import { FC, useCallback, useState } from 'react';
import styled from 'styled-components';

import { useActiveMvpd } from '#/hooks/useActiveMvpd';
import { remify } from '#/service/utils';

interface StyledImageProps {
  $isVisible: boolean;
  $isCentered: boolean;
}

const StyledImage = styled.img<StyledImageProps>`
  height: ${remify(30)};
  width: auto;
  align-self: center;
  ${({ $isVisible }) => !$isVisible && 'visibility: hidden;'}
  ${({ $isCentered }) =>
    $isCentered &&
    `
    width: 100%;
    object-fit: contain;
  `}
`;

interface LogoMvpdProps {
  isCentered?: boolean;
}

export const LogoMvpd: FC<LogoMvpdProps> = ({ isCentered = false }) => {
  const { logoUrl, name } = useActiveMvpd() || {};
  const [visible, setVisible] = useState(false);
  const onLoad = useCallback(() => {
    setVisible(true);
  }, []);

  if (!logoUrl) {
    return null;
  }

  return (
    <StyledImage
      $isCentered={isCentered}
      $isVisible={visible}
      alt={name}
      data-testid="mvpd-logo"
      onLoad={onLoad}
      src={logoUrl}
    />
  );
};
